import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSummaryRoute: InvariantJiraRoute = {
	name: 'software-plan-summary',
	path: '/jira/plans/:planId/scenarios/:scenarioId/summary',
};
